import React, {FC, useState} from 'react'
import {useStatusMessage} from '../../../features'
import {Post} from '../../../../setup'
import {useFormik} from 'formik'
import {useForms} from '../../../@contexts/pages/web-forms/FormsProvider'

interface UpdateStatusInterface {
  status: string
  id: string
}

const initialValues = {
  status: '0',
}

const UPDATE_STATUS = process.env.REACT_APP_WEB_FORMS_UPDATE_STATUS

const UpdateStatus: FC<UpdateStatusInterface> = ({id, status}) => {

  const {allStatus} = useForms()

  const {formState, setLoading} = useStatusMessage()
  const [successReq, setSuccessReq] = useState<boolean>(false)
  const endpoint = `${UPDATE_STATUS}/${id}`

  const onSubmit = async (values: typeof initialValues, {setSubmitting}: {
    setSubmitting: (isSubmitting: boolean) => void
  }) => {

    setLoading(true)

    try {
      const {status} = await Post<any>(endpoint, values)

      if (status === 200) {
        setSuccessReq(true)
        setTimeout(() => {
          setSuccessReq(false)
        }, 3000)
      }

    } catch (err) {
      console.error('Error submitting the form:', err)
    } finally {
      setLoading(false)
      setSubmitting(false)
    }
  }

  const formik = useFormik({
    initialValues: {status: status || '0'},
    enableReinitialize: true,
    onSubmit,
  })

  return (
    <>
      <form onSubmit={formik.handleSubmit}>
        <div className="flex-grow-1 me-2 mb-1">
          <label htmlFor="updateStatus" className="text-muted fw-bold d-block">Modifier le statut</label>
        </div>
        <div className="row d-flex justify-content-center align-items-center">
          <div className="col-4">
            <select className="form-select form-select-sm"
                    id={`status_${id}`}
                    {...formik.getFieldProps('status')}
            >
              {allStatus.map((status, index) => (
                <option value={status.id} key={index}>{status.name}</option>
              ))}
            </select>
          </div>
          <div className="col-8 d-flex justify-content-end align-items-center">
            <button type="submit" className={`btn btn-sm btn-${successReq ? 'success' : 'primary'}`}
                    disabled={formState.loading}
            >
              {formState.loading ? (
                <span className="indicator-progress d-block">
                    S'il vous plaît, attendez... <span className="spinner-border spinner-border-sm align-middle ms-2" />
                  </span>
              ) : (
                'Sauvegarder'
              )}
            </button>
          </div>
        </div>


      </form>
    </>
  )
}

export {UpdateStatus}